export default __webpack_public_path__ + "static/social4-49a221b416067d1d48324417a0112e57.png";